import React, { useState, useEffect } from "react";
import Container from "./styled";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { BsWhatsapp } from "react-icons/bs";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
import "tippy.js/animations/scale-subtle.css";
import "tippy.js/animations/scale-extreme.css";

export default function Cotizador() {
  // Valor dinámico del rango del cotizador
  const [rangeval, setRangeval] = useState(40000);
  // Valores de los inputs
  const [inputValues, setInputValues] = useState({});
  // Errpres del formulario
  const [formErrors, setFormErrors] = useState({});
  const [prefijos, setPrefijos] = useState([]);
  const [valoresAlta, setValoresAlta] = useState([]);
  const [valoresResto, setValoresResto] = useState([]);
  const navigate = useNavigate();

  // Estilos del input de rango para setear el valor de la bici
  for (let e of document.querySelectorAll(".sliderProgress")) {
    e.style.setProperty("--value", e.value);
    e.style.setProperty("--min", e.min == "" ? "0" : e.min);
    e.style.setProperty("--max", e.max == "" ? "100" : e.max);
    e.addEventListener("input", () => e.style.setProperty("--value", e.value));
  }

  const [searchParams, setSearchParams] = useSearchParams();
  const [ip, setIp] = useState("");
  const utm_source = searchParams.get("utm_source");
  const utm_medium = searchParams.get("utm_medium");
  const utm_campaign = searchParams.get("utm_campaign");
  const channel = 5;

  useEffect(() => {
    const data = async () => {
      const res = await axios.get("https://geolocation-db.com/json/");
      console.log(res.data);
      setIp(res.data.IPv4);
      console.log(res.data.IPv4);
    };
    data();
  }, []);

  // Obtener prefijos de la base para validar en conjunto con el ingresado por el usuario.
  useEffect(() => {
    const getPrefixes = async () => {
      try {
        const prefixes = await axios.get(
          "https://heroku-gys-server-test.herokuapp.com/prefijos"
        );
        const valores_alta = await axios.get(
          "http://localhost:5000/valores_alta"
        );
        const valores_resto = await axios.get(
          "http://localhost:5000/valores_resto"
        );
        setPrefijos(prefixes.data);
        setValoresAlta(valores_alta.data);
        setValoresResto(valores_resto.data);
        console.log(prefixes.data);
      } catch (error) {
        console.log("Hubo un error", error);
      }
    };
    getPrefixes();
  }, []);

  // Setea el valor de los inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prev) => ({ ...prev, [name]: value }));
    // Guarda el valor de cada input en el localStorage con su nombre para autocompletar el paso 3
    localStorage.setItem([name], value);
  };

  // Validar Formulario
  const validateForm = (e) => {
    e.preventDefault();
    let errors = {};
    let cobertura;

    if (!inputValues.email) {
      errors.email = "Este campo es requerido.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValues.email)) {
      errors.email = "El email ingresado no es valido.";
    }

    // Validar provincia
    if (!inputValues.localidad) {
      errors.localidad = "Este campo es requerido.";
    }

    // Valor
    if (rangeval && inputValues.localidad) {
      const valores =
        inputValues.localidad === "Resto del Pais" ? valoresResto : valoresAlta;
      const findCoberturas = valores.find((valor) => {
        return valor.suma_aseg == rangeval;
      });
      cobertura = findCoberturas;
    }

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      sendData();
    }

    /*
    // Validar nombre
    if (!inputValues.nombre) {
      errors.nombre = "Este campo es requerido.";
    } else if (inputValues.nombre.length < 2) {
      errors.nombre = "El campo nombre debe contener al menos 2 caracteres.";
    } else if (
      !/^[a-zA-Z\u00C0-\u017F!@#$%^&':"\\|,.<>\/?\s\u00f1\u00d1]*$/.test(
        inputValues.nombre
      )
    ) {
      errors.nombre = "El nombre ingresado no es válido.";
    }

    // Validar apellido
    if (!inputValues.apellido) {
      errors.apellido = "Este campo es requerido.";
    } else if (inputValues.apellido.length < 2) {
      errors.apellido =
        "El campo apellido debe contener al menos 2 caracteres.";
    } else if (
      !/^[a-zA-Z!@#$%^&':"\\|,.<>\/?\s\u00f1\u00d1]*$/.test(
        inputValues.apellido
      )
    ) {
      errors.apellido = "El apellido ingresado no es válido.";
    }
    */

    /*
    // Validar teléfono
    if (!inputValues.telefono) {
      errors.telefono = "Este campo es requerido.";
    } else if (inputValues.telefono.length < 8) {
      errors.telefono = "El campo telefono es menor a 8 digitos.";
    }

    // Validar código de área
    if (!inputValues.codigoArea) {
      errors.codigoArea = "Este campo es requerido.";
    } else if (
      inputValues.codigoArea.length < 2 ||
      inputValues.codigoArea.length > 5
    ) {
      errors.codigoArea =
        "El código de área debe tener más de 2 digitos y menos de 5.";
    } else {
      const checkPrefix = prefijos.some((prefix) => {
        return inputValues.codigoArea === prefix.prefijo;
      });
      if (!checkPrefix) {
        errors.codigoArea = "El código de área ingresado no es válido.";
      }
    }
    */
  };

  const sendData = async () => {
    const origen = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent
    )
      ? "mobile"
      : "web";
    const landing_url = window.location.href.split("/");
    console.log(landing_url[3]);

    const data = {
      nombre: inputValues.nombre,
      email: inputValues.email,
      valor: rangeval,
      prefijo: inputValues.codigoArea,
      telefono: inputValues.telefono,
      localidad: inputValues.localidad,
      utm_source: utm_source ? utm_source : "",
      utm_medium: utm_medium ? utm_medium : "",
      utm_campaign: utm_campaign ? utm_campaign : "",
      landing: "bicicleterias",
      origen: origen,
      tipo: "comun",
      marca: "",
      extra: "",
      bicicleteria: "1",
      delivery: "",
      ip_address: ip,
      landing_url: landing_url[3],
      url_ingreso: window.location.href,
    };
    console.log(data);
    const post = await axios.post("http://localhost:5000/valores", data);
    console.log(post);
    if (post.status === 200) {
      post.data.precios.valor = rangeval;
      navigate("/pasos", { state: post.data });
    }
  };

  console.log(inputValues.nombre);

  return (
    <Container>
      {/* Cotizador Container */}
      <div className="cotizadorContainer opacidad08">
        <div className="titleFormularioContainer">
          {/* Titles */}
          <h1>¡Cotizá tu seguro!</h1>
          <h3>Protegete ante cualquier improvisto y ahorrá</h3>
          {/* Formulario Container */}
          <div className="formularioContainer">
            {/* Formulario */}
            <form>
              {/* Input Range Container*/}
              <div className="inputRangeContainer">
                <p>Valor de bicicleta</p>
                {/* Este condicional no afeca el valor inicial del input, solo afecta la forma de mostrarlo.
              si alguien lo deja en 40000 como aparece por default, va a funcionar */}
                {/* Cambiar este valor si cambia el defaultValue del input */}
                <p>${rangeval == null ? "40000" : rangeval}</p>
                {/* Input Range */}
                <input
                  type="range"
                  id="inputValorBici"
                  name="valorBici"
                  step="5000"
                  min="20000"
                  max="500000"
                  defaultValue="40000"
                  onChange={(event) => setRangeval(event.target.value)}
                  className="sliderProgress"
                ></input>
                <p>$20.000</p>
                <p>$500.000</p>
              </div>
              {/* Other Inputs Container*/}
              <div className="otherInputsContainer">
                {/* Input Nombre */}
                <div className="inputContainer" id="inputNombreContainer">
                  <input
                    type="text"
                    id="inputNombre"
                    name="nombre"
                    onChange={handleChange}
                    onFocus={handleChange}
                    onBlur={handleChange}
                    value={inputValues.nombre}
                    className={formErrors.nombre == null ? "" : "inputError"}
                  ></input>
                  <label
                    className={
                      inputValues.nombre == null || inputValues.nombre == ""
                        ? "labelDown"
                        : "labelTop"
                    }
                    for="inputNombre"
                  >
                    Nombre
                  </label>
                </div>
                {/* Input Apellido */}
                <div className="inputContainer" id="inputApellidoContainer">
                  <input
                    type="text"
                    id="inputApellido"
                    name="apellido"
                    onChange={handleChange}
                    onFocus={handleChange}
                    onBlur={handleChange}
                    value={inputValues.apellido}
                    className={formErrors.apellido == null ? "" : "inputError"}
                  ></input>
                  <label
                    className={
                      inputValues.apellido == null || inputValues.apellido == ""
                        ? "labelDown"
                        : "labelTop"
                    }
                    for="inputApellido"
                  >
                    Apellido
                  </label>
                </div>
                {/* Input Email */}
                <div className="inputContainer" id="inputEmailContainer">
                  <input
                    type="email"
                    id="inputEmail"
                    name="email"
                    onChange={handleChange}
                    onFocus={handleChange}
                    onBlur={handleChange}
                    value={inputValues.email}
                    className={formErrors.email == null ? "" : "inputError"}
                  ></input>
                  <label
                    className={
                      inputValues.email == null || inputValues.email == ""
                        ? "labelDown"
                        : "labelTop"
                    }
                    for="inputEmail"
                  >
                    Email
                  </label>
                </div>
                {/* Input Codigo de Area */}
                <div className="inputContainer" id="inputCodigoAreaContainer">
                  <input
                    type="number"
                    name="codigoArea"
                    id="inputCodigoArea"
                    onChange={handleChange}
                    onFocus={handleChange}
                    onBlur={handleChange}
                    value={inputValues.codigoArea}
                    className={
                      formErrors.codigoArea == null ? "" : "inputError"
                    }
                  ></input>
                  <label
                    className={
                      inputValues.codigoArea == null ||
                      inputValues.codigoArea == ""
                        ? "labelDown"
                        : "labelTop"
                    }
                    for="inputCodigoArea"
                  >
                    Cod. Área
                  </label>
                </div>
                {/* Input Telefono */}
                <div className="inputContainer" id="inputTelefonoContainer">
                  <input
                    type="number"
                    id="inputTelefono"
                    name="telefono"
                    onChange={handleChange}
                    onFocus={handleChange}
                    onBlur={handleChange}
                    value={inputValues.telefono}
                    className={formErrors.telefono == null ? "" : "inputError"}
                  ></input>
                  <label
                    className={
                      inputValues.telefono == null || inputValues.telefono == ""
                        ? "labelDown"
                        : "labelTop"
                    }
                    for="inputTelefono"
                  >
                    Teléfono
                  </label>
                </div>
                {/* Select Container */}
                <div className="selectContainer">
                  {/* Select Localidad */}
                  <select
                    id="selectLocalidad"
                    name="localidad"
                    value={inputValues.localidad}
                    onChange={handleChange}
                    onFocus={handleChange}
                    onBlur={handleChange}
                    className={formErrors.localidad == null ? "" : "inputError"}
                  >
                    {/* Opción por predeterminado */}
                    <option disabled selected></option>
                    <option value="Capital Federal y Gran Buenos Aires">
                      Capital Federal y Gran Buenos Aires
                    </option>
                    <option value="Berisso">Berisso</option>
                    <option value="Ensenada">Ensenada</option>
                    <option value="Escobar">Escobar</option>
                    <option value="Exaltacion de la Cruz">
                      Exaltación de la Cruz
                    </option>
                    <option value="General Rodriguez">General Rodriguez</option>
                    <option value="La Plata">La Plata</option>
                    <option value="Lujan">Luján</option>
                    <option value="Marcos Paz">Marcos Paz</option>
                    <option value="Merlo">Merlo</option>
                    <option value="Moreno">Moreno</option>
                    <option value="Pilar">Pilar</option>
                    <option value="San Vicente">San Vicente</option>
                    <option value="Resto del Pais">Resto del País</option>
                  </select>
                  <label
                    className={
                      inputValues.localidad == null ||
                      inputValues.localidad == ""
                        ? "labelDown"
                        : "labelTop"
                    }
                    for="selectLocalidad"
                  >
                    Localidad
                  </label>
                  <i></i>
                </div>
              </div>
              <div className="buttonsContainer">
                {/* Whatsapp Button */}
                <Tippy content="De Lun. a Vie. de 9 a 18hs" animation="scale">
                  <a
                    href="https://api.whatsapp.com/send?phone=541138043972&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20Seguro%20de%20Bici!%20"
                    target="_blank"
                  >
                    <span>
                      <BsWhatsapp />
                    </span>
                    Necesito ayuda
                  </a>
                </Tippy>
                {/* Cotizar Button */}
                <button type="submit" onClick={validateForm}>
                  Cotizar bicicleta
                  <img
                    alt="Ícono de bicicleta"
                    src="./images/home/iconcotizador.svg"
                  ></img>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ilustration Container */}
      <div className="ilustrationContainer opacidad12">
        {/* Ilustration */}
        <img
          alt="Seguro Bici Ilustracion"
          src="images/home/cotizador.svg"
        ></img>
      </div>
    </Container>
  );
}
